<mat-card>
    <mat-card-header>
        <mat-card-title>
            <h2 *ngIf="!isMJP">
                {{'partitions.projectionRate.title.shortLabel' | translate}}
                <app-tooltip text="{{'partitions.projectionRate.title.summary' | translate}}"></app-tooltip>
            </h2>
            <h2 *ngIf="isMJP">
                {{'partitions.projectionRate.titleMjp.shortLabel' | translate}}
                <app-tooltip text="{{'partitions.projectionRate.titleMjp.summary' | translate}}"></app-tooltip>
            </h2>
        </mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <form [formGroup]="paramForm" class="param-form">
            <mat-form-field *ngIf="ratesArray.length">
                <mat-label>{{(isMJP ?
                    'partitions.projectionRate.dropdown.title.mjp.shortLabel' :
                    'partitions.projectionRate.dropdown.title.default.shortLabel') | translate}}</mat-label>
                <mat-select name="rates" formControlName="rates" [disabled]="this.isNullMJP">
                    <mat-optgroup *ngFor="let rateGroup of ratesArray" [label]="rateGroup.label">
                        <mat-option *ngFor="let rate of rateGroup.rates" [(value)]="rate.id">
                            {{ rate.text.shortLabel }}
                        </mat-option>
                    </mat-optgroup>
                </mat-select>
            </mat-form-field>

            <mat-form-field>
                <input matInput type="number" inputmode="numeric"
                    onclick="this.select()"
                    name="rate"
                    formControlName="rate"
                    step="0.01">
                <span matSuffix> %</span>
                <mat-error>{{'partitions.projectionRate.input.errorMessage.summary' | translate}}</mat-error>
            </mat-form-field>

            <section>
                <mat-checkbox *ngIf="!isMJP" name="neutralize" formControlName="neutralize"
                    [matTooltip]="'partitions.projectionRate.neutralize.summary' | translate">
                    {{'partitions.projectionRate.neutralize.shortLabel' | translate}}
                </mat-checkbox>
                <mat-form-field *ngIf="isMJP">
                    <mat-label>{{'partitions.projectionRate.years.shortLabel' | translate}}</mat-label>
                    <mat-select name="years" formControlName="years" multiple formArrayName="items">
                        <ng-container *ngFor="let option of partition.simulationValues.years; let i = index;">
                            <div class="param-form-year" [formGroupName]="i">
                                <mat-option *ngIf="option.isEstimated"  [value]="option.year">
                                    {{ option.year }}
                                </mat-option>
                                <mat-form-field *ngIf="option.isEstimated && !option.isRateNeutralized">
                                    <input matInput type="number" inputmode="numeric"
                                        onclick="this.select()"
                                        step="0.01"
                                        formControlName="indice">
                                    <span matSuffix> %</span>
                                </mat-form-field>
                            </div>
                        </ng-container>
                    </mat-select>
                </mat-form-field>
            </section>
        </form>
    </mat-card-content>
</mat-card>
